import { useState } from 'react'
import { Modal, Button } from 'antd'
import OtpInput from 'react-otp-input'
import useTranslation from '@/hooks/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import { updateEmail, verifyEmail } from '@/features/auth/apis/authSlice'
import { errorHandling, openNotification } from '@/utils/utils'

import Close from '@/components/svgs/CloseModal'
import Refresh from '@/components/svgs/auth/Refresh'

const VerifyEmailOTP = ({ open, setOpen, newEmail }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { updateLoading } = useSelector((state) => state.auth)

  const [otp, setOtp] = useState('')

  // HANDLE SUBMIT
  const handleSubmit = () => {
    dispatch(verifyEmail({ email: newEmail, otp }))
      .unwrap()
      .then((data) => {
        openNotification('success', data.message)
        setOpen(false)
      })
      .catch((error) => openNotification('error', errorHandling(error)))
  }

  return (
    <Modal
      className='!w-[32rem]'
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={false}
      centered
    >
      <div className='text-center mb-32 mt-16'>
        <h3 className='text-xl font-semibold capitalize mb-16'>
          {t('codice di verifica')}
        </h3>
        <p className='text-dimmed leading-6 text-sm'>
          {t('Enter the code sent to your new email.')}
        </p>
      </div>

      <div className='otp-input-2 flex justify-center'>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={4}
          renderSeparator={<span className='text-transparent'>-</span>}
          renderInput={(props) => <input {...props} />}
        />
      </div>

      <Button
        className='btn-green text-base font-semibold tracking-wide rounded-lg py-12 w-full h-auto mt-24'
        loading={updateLoading}
        onClick={handleSubmit}
      >
        {t('Confirm')}
      </Button>

      <p className='text-dimmed text-sm flex justify-center gap-8 mt-16'>
        {t('Non hai ricevuto il messaggio?')}
        <span
          className='text-green flex gap-4 cursor-pointer'
          onClick={() => {
            dispatch(updateEmail(newEmail))
              .unwrap()
              .then((data) => {
                openNotification('success', data.message)
              })
              .catch((error) => openNotification('error', errorHandling(error)))
          }}
        >
          <Refresh />
          {t('Reinvio')}
        </span>
      </p>

      <Close
        style='absolute top-28 right-36 cursor-pointer'
        onClick={() => setOpen(false)}
      />
    </Modal>
  )
}

export default VerifyEmailOTP
